import { isBusinessDay } from "@goodfill/business-days";
import { DateObjectUnits, DateTime } from "luxon";

const US_OPEN_TIME: DateObjectUnits = { hour: 8, minute: 0, second: 0, millisecond: 0 };
const US_CLOSE_TIME: DateObjectUnits = { hour: 17, minute: 0, second: 0, millisecond: 0 };
export type UsMarketOpenness = "Before" | "Open" | "After" | "OffDay";

export const getUsMarketOpenness = (dateTime: DateTime): UsMarketOpenness => {
  const zonedDateTime = dateTime.setZone("America/New_York");

  if (!isBusinessDay(zonedDateTime)) {
    return "OffDay";
  }

  const open = zonedDateTime.set(US_OPEN_TIME);
  const close = zonedDateTime.set(US_CLOSE_TIME);

  if (zonedDateTime < open) {
    return "Before";
  } else if (zonedDateTime >= close) {
    return "After";
  } else {
    return "Open";
  }
};
